import React from 'react';
import { motion } from 'framer-motion';
import Button from './Button';
import './CTA.css';

const CTA = ({ 
  title, 
  description, 
  buttonText, 
  buttonLink,
  variant = 'primary',
  fullWidth = false
}) => {
  return (
    <motion.section 
      className={`cta ${variant} ${fullWidth ? 'full-width' : ''}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="cta-container">
        <div className="cta-content">
          <motion.h2
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            {title}
          </motion.h2>
          {description && (
            <motion.p
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              {description}
            </motion.p>
          )}
        </div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <Button 
            to={buttonLink} 
            primary={variant === 'primary'}
            secondary={variant === 'secondary'}
            large
          >
            {buttonText}
          </Button>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default CTA;